import React from 'react';
import { Grid } from '@mui/material';
import { FormDataConsumer, RadioButtonGroupInput, TextInput } from 'react-admin';
import { scoringTypes } from '../../../constants';

const FormScoringType: React.FC<{ formData?: any }> = ({ formData }) => {
  const scoringTypeChoices = Object.entries(scoringTypes).map(([value, label]) => ({ value, label }));

  return (
    <>
      <RadioButtonGroupInput
        label="Tipo de pontuação"
        source="type"
        choices={!!formData?.customerIds ? scoringTypeChoices.filter(d => d.value === 'special') : scoringTypeChoices}
        defaultValue="special"
        optionText="label"
        optionValue="value"
      />
      <FormDataConsumer>
        {({ formData }) => formData.type === 'special' && (
          <Grid container sx={{ maxWidth: 500 }}>
            <Grid size={12}>
              <TextInput source="description" label="Descrição" required fullWidth />
            </Grid>
          </Grid>
        )}
      </FormDataConsumer>
    </>
  );
}

export default FormScoringType;
